import React from 'react'
import { ReactComponent as ErrorIcon } from 'static/svg/icon-error.svg'
import { CapacityState } from 'services/metrics/types'
import { CapacityMessage } from './CapacityMessage'
import * as S from './styles'

interface Props {
  title: string;
  variant: 'info' | 'danger';
  state: CapacityState;
}

export const CapacityBanner: React.FC<Props> = ({ title, variant, state }) => (
  <S.Banner
    $variant={variant}
    role={variant === 'info' ? 'status' : 'alert'}
  >
    <S.BannerWrapper>
      <S.BannerIcon $variant={variant}>
        <ErrorIcon aria-hidden="true" />
      </S.BannerIcon>
      <S.BannerContent>
        <S.BannerTitle>{title}</S.BannerTitle>
        <S.BannerMessage>
          <CapacityMessage state={state} />
        </S.BannerMessage>
      </S.BannerContent>
    </S.BannerWrapper>
  </S.Banner>
)
